<template>
  <div class="m-search-page">
    <a-auto-complete
    v-model="form.search"
    :placeholder="$t('search.placeholder')"
    :filter-option="filterOption"
    @change="oncChangeSearch"
    optionLabelProp="value"
    >
      <template slot="dataSource">
          <a-select-option
            v-for="item in searchItems"
            :key="item.value"
            :value="item.value" >
            {{ item.label }}
          </a-select-option>

        </template>
        <a-input-search @search="onSearch"></a-input-search>

    </a-auto-complete>

    <a-list
      :data-source="list"
      :locale="{emptyText: ' '}"
    >
    <!-- :locale="{emptyText: this.$t('no.search.results')}" -->
      <a-list-item slot="renderItem" slot-scope="item, index" >

        <a class="m-link" v-if="item.type==='2'" :href="`${item.url}`" target="_blank">
          <!-- <div class="m-list-item-left"> -->
            <i class="type-2-web"></i>
            <span class="m-list-number">{{ item.code }}</span>
          <!-- </div> -->
          <span :num="index" class="m-list-text">{{ item.title }}
            <span
              class="m-clipboard"
              v-clipboard:copy="`${item.url}`"
              v-clipboard:success="copySuccess"
              v-clipboard:error="onError"
              @click.stop="doNothing"
              :title="`${$t('copy.link')}`"
            ></span>
          </span>
        </a>

        <a class="m-link" v-else :href="`https://support.sigma-rt.com.cn/tchelp/view?language=${currentLang}&productId=7&id=${item.id}`" target="_blank">
          <!-- <div class="m-list-item-left"> -->
          <i class="type-1-show" v-if="item.type==='1'"></i>
          <i class="type-3-goto" v-if="item.type==='3'"></i>
          <i class="type-4-script" v-if="item.type==='4'"></i>
          <i class="type-5-install" v-if="item.type==='5'"></i>
          <span class="m-list-number">{{ item.code }}</span>
        <!-- </div> -->
          <span :num="index" class="m-list-text">{{ item.title }}

            <span
              class="m-clipboard"
              v-clipboard:copy="`https://support.sigma-rt.com.cn/tchelp/view?language=${currentLang}&productId=7&id=${item.id}`"
              v-clipboard:success="copySuccess"
              v-clipboard:error="onError"
              @click.stop="doNothing"
              :title="`${$t('copy.link')}`"
            ></span>
          </span>

        </a>

      </a-list-item>
      <div slot="header" v-show="result">
        <template v-if="list.length !== 0">
          {{ $t('search.result', { search: this.form.search, number: list.length}) }}
        </template>
        <template v-else>
          {{ $t('no.search.results') }}&nbsp;<a href="mailto:support@sigma-rt.com">{{ $t('email.to.us') }}</a>
        </template>
      </div>
      <!-- <div slot="footer">
        Footer
      </div> -->
    </a-list>
  </div>
</template>

<script>
import { getHelpSearch } from '@/api/help'
import storage from 'store'

export default {
  name: 'SearchView',
  props: ['lang'],
  data () {
    return {
      list: [],
      searchItems: storage.get('search') ? storage.get('search') : [],
      form: {
        search: '',
        language: this.$store.getters.lang === 'en-US' ? 'en' : 'cn',
        productId: 7,
        version: ''
      },
      result: false
    }
  },
  computed: {
    currentLang () {
      let lang = this.$store.state.app.lang
      if (lang === 'en-US') {
        lang = 'en'
      }

      if (lang === 'zh-CN') {
        lang = 'cn'
      }
      return lang
    }
  },
  created: function () {

  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      )
    },
    onError () {

    },
    copySuccess () {
      return this.$message.info(this.$t('copy.success'))
    },
    doNothing (event) {
      // 阻止事件冒泡
      event.stopPropagation()
      event.preventDefault()
    },
    onSearch (value) {
      if (this.form.search !== '') {
        this.getSearchTCHelpInfo(this.form, true, value)
      } else {
        this.result = false
        this.list = []
      }
    },
    oncChangeSearch (value) {
      if (this.form.search !== '') {
        this.getSearchTCHelpInfo(this.form, false, value)
      } else {
        this.result = false
        this.list = []
      }
    },

    async getSearchTCHelpInfo (obj, flag, value) {
      const { data: res } = await getHelpSearch(obj)
      console.log('getSearchTCHelpInfo >>', res)
      this.list = res.data || []
      this.result = true

      if (flag && this.list.length > 0) {
        const getSearchData = storage.get('search') ? storage.get('search') : []
        if (getSearchData instanceof Array && getSearchData.length >= 10) {
          getSearchData.shift()
        }

        if (getSearchData instanceof Array) {
          const objectExists = getSearchData.some(item => item.value === value)
          if (!objectExists) {
            getSearchData.push({ value: value, label: value })
            storage.set('search', getSearchData)
            this.searchItems = getSearchData
          }
        } else {
          storage.set('search', [])
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.m-search-page {
  padding: 10px 20px;
}
.ant-input-search {
  // margin-bottom: 20px;
}
.ant-select {
  display: block;
}
.ant-list {
  text-align: left;
}

// /deep/.ant-list-header {
//   text-align: center;
// }

/deep/.ant-list-split {
  .ant-list-header {
    border-bottom: none;
  }
  .ant-list-item{
    &:first-child {
      border-top: 1px solid #e8e8e8;
    }

    &:hover {
      background-color: #f6fbff;
    }
  }
}

.m-list-number {
  display: inline-block;
  padding: 0 18px;
  color: #36b8f3;

}

.m-list-text {
  display: inline-block;
  font-size: 16px;
  color: #000000;
  position: relative;
  padding-right: 28px;
}
.ant-list-item {
  display: block;

  .m-clipboard {
    position: absolute;
    display: none;
    width: 24px;
    height: 16px;
    top: 4px;
    right: 0;
    background: url(~@/assets/img/copy-link.png) no-repeat center center;
    vertical-align: text-top;
    cursor: pointer;
    z-index: 1000;
  }

  &:hover {
    .m-clipboard {
      display: inline-block;
    }
  }

  .m-link {
    display: flex;
    flex-direction: row;
  // width: 100%;
  flex-wrap: no-wrap;
  justify-content: flex-start;
  }
}
.m-list-item-left {
  width: 95px;
  display: inline-block;
}
.type-1-show,
.type-2-web,
.type-3-goto,
.type-4-script,
.type-5-install {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: text-top;
  flex: 0 0 auto;
}

.type-1-show {
  background: url("~@/assets/img/help_show.png") no-repeat center center;
}

.type-2-web {
  background: url('~@/assets/img/help_web.png') no-repeat center center;
}

.type-3-goto {
  background: url('~@/assets/img/help_goto.png') no-repeat center center;
}

.type-4-script {
  background: url('~@/assets/img/help_script.png') no-repeat center center;
}
.type-5-install {
  background: url('~@/assets/img/help_download.png') no-repeat center center;
}

</style>
